import React, { useEffect } from "react";
import User from "./user";
import TermsAndConditions from "./terms";
import AceTypeSelection from "./aceType";
import CompanySelection from "./companies";
import "./register.css";
import PaymentComponent from "./payment";
import { Navbar } from "reactstrap";

function getSteps() {
  return ["Step1", "Step2", "Step3", "Step4", "Step5"];
}

export default function RegistraionFlow() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [user, setRegUserInfo] = React.useState({});
  const [selectedAceType, setSelectedAceType] = React.useState("");
  const [purchaseLimit, setPurchaseLimit] = React.useState("");
  const [totalValue, setTotalValue] = React.useState(0);
  const [selectedList, setSelectedList] = React.useState([]);

  const steps = getSteps();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  function getStepContent(stepIndex) {
    const input = { handleNext, handleBack };
    switch (stepIndex) {
      case 0:
        return <User setRegUserInfo={setRegUserInfo} {...input} />;
      case 1:
        return <TermsAndConditions user={user} {...input} />;
      case 2:
        return (
          <AceTypeSelection
            user={user}
            setSelectedAceType={setSelectedAceType}
            setPurchaseLimit={setPurchaseLimit}
            {...input}
          />
        );
      case 3:
        return (
          <CompanySelection
            user={user}
            selectedAceType={selectedAceType}
            purchaseLimit={purchaseLimit}
            totalValue={totalValue}
            setTotalValue={setTotalValue}
            selectedList={selectedList}
            setSelectedList={setSelectedList}
            {...input}
          />
        );
      case 4:
        return (
          <PaymentComponent
            amount={totalValue}
            user={user}
            selectedList={selectedList}
            handleBack={handleBack}
          />
        );
      default:
        return "Unknown stepIndex";
    }
  }

  const handleNavigation = () => {
    window.location.href = "/";
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [activeStep]);

  return (
    <main className={"ContentRegister"}>
      <Navbar className={"NavBar"}>
        <div onClick={handleNavigation} style={{ cursor: 'pointer'}}>
          <img src="/SAR-Logo-White.png" className={"SARLogo"} alt="SAR" />
        </div>
      </Navbar>
      <div className={"NavDivider"} />
      <div>
        {activeStep === steps.length ? (
          <div>
            <p>All steps completed</p>
            <button onClick={handleReset}>Reset</button>
          </div>
        ) : (
          <div>{getStepContent(activeStep)}</div>
        )}
      </div>
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/components/Register/register.jsx